// generated with @7nohe/openapi-react-query-codegen@1.6.2
import { ConfigurationService } from "../requests/services.gen";

import { UseQueryResult } from "@tanstack/react-query";

export type ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartPositionsCountDefaultResponse =
  Awaited<
    ReturnType<
      typeof ConfigurationService.getCustomApiConfigurationPublicShoppingCartPositionsCount
    >
  >;
export type ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartPositionsCountQueryResult<
  TData =
    ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartPositionsCountDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useConfigurationServiceGetCustomApiConfigurationPublicShoppingCartPositionsCountKey =
  "ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartPositionsCount";
export const UseConfigurationServiceGetCustomApiConfigurationPublicShoppingCartPositionsCountKeyFn =
  (
    {
      localeId,
      userSessionId,
      userToken,
    }: {
      localeId?: string | undefined;
      userSessionId?: string | undefined;
      userToken?: string | undefined;
    } = {},
    queryKey?: Array<unknown>,
  ) => [
    useConfigurationServiceGetCustomApiConfigurationPublicShoppingCartPositionsCountKey,
    ...(queryKey ?? [{ localeId, userSessionId, userToken }]),
  ];
export type ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataDefaultResponse =
  Awaited<
    ReturnType<
      typeof ConfigurationService.getCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedData
    >
  >;
export type ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataQueryResult<
  TData =
    ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useConfigurationServiceGetCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataKey =
  "ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedData";
export const UseConfigurationServiceGetCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataKeyFn =
  (
    {
      quoteId,
      userSessionId,
      userToken,
    }: {
      quoteId: string;
      userSessionId?: string | undefined;
      userToken?: string | undefined;
    },
    queryKey?: Array<unknown>,
  ) => [
    useConfigurationServiceGetCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataKey,
    ...(queryKey ?? [{ quoteId, userSessionId, userToken }]),
  ];
export type ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataDefaultResponse =
  Awaited<
    ReturnType<
      typeof ConfigurationService.getCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedData
    >
  >;
export type ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataQueryResult<
  TData =
    ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useConfigurationServiceGetCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataKey =
  "ConfigurationServiceGetCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedData";
export const UseConfigurationServiceGetCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataKeyFn =
  (
    {
      lineItemId,
      userSessionId,
      userToken,
    }: {
      lineItemId: string;
      userSessionId?: string | undefined;
      userToken?: string | undefined;
    },
    queryKey?: Array<unknown>,
  ) => [
    useConfigurationServiceGetCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataKey,
    ...(queryKey ?? [{ lineItemId, userSessionId, userToken }]),
  ];
export type ConfigurationServiceGetCustomApiConfigurationPublicHelloWorldDefaultResponse =
  Awaited<
    ReturnType<
      typeof ConfigurationService.getCustomApiConfigurationPublicHelloWorld
    >
  >;
export type ConfigurationServiceGetCustomApiConfigurationPublicHelloWorldQueryResult<
  TData =
    ConfigurationServiceGetCustomApiConfigurationPublicHelloWorldDefaultResponse,
  TError = unknown,
> = UseQueryResult<TData, TError>;
export const useConfigurationServiceGetCustomApiConfigurationPublicHelloWorldKey =
  "ConfigurationServiceGetCustomApiConfigurationPublicHelloWorld";
export const UseConfigurationServiceGetCustomApiConfigurationPublicHelloWorldKeyFn =
  (queryKey?: Array<unknown>) => [
    useConfigurationServiceGetCustomApiConfigurationPublicHelloWorldKey,
    ...(queryKey ?? []),
  ];
export type ConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorMutationResult =
  Awaited<
    ReturnType<
      typeof ConfigurationService.postCustomApiConfigurationPublicStartConfigurator
    >
  >;
export type ConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgKonfigStandardMutationResult =
  Awaited<
    ReturnType<
      typeof ConfigurationService.postCustomApiConfigurationPublicStartConfiguratorCfgKonfigStandard
    >
  >;
export type ConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorMutationResult =
  Awaited<
    ReturnType<
      typeof ConfigurationService.postCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfigurator
    >
  >;
export type ConfigurationServicePostCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorSchnellMutationResult =
  Awaited<
    ReturnType<
      typeof ConfigurationService.postCustomApiConfigurationPublicStartConfiguratorCfgProfiKonfiguratorSchnell
    >
  >;
export type ConfigurationServicePostCustomApiConfigurationPublicShoppingCartConfigurationsMutationResult =
  Awaited<
    ReturnType<
      typeof ConfigurationService.postCustomApiConfigurationPublicShoppingCartConfigurations
    >
  >;
export type ConfigurationServicePostCustomApiConfigurationPublicShoppingCartConfigurationsEditMutationResult =
  Awaited<
    ReturnType<
      typeof ConfigurationService.postCustomApiConfigurationPublicShoppingCartConfigurationsEdit
    >
  >;
export type ConfigurationServicePostCustomApiConfigurationPublicShoppingCartShowMutationResult =
  Awaited<
    ReturnType<
      typeof ConfigurationService.postCustomApiConfigurationPublicShoppingCartShow
    >
  >;
export type ConfigurationServicePostCustomApiConfigurationPublicShoppingCartProductsMutationResult =
  Awaited<
    ReturnType<
      typeof ConfigurationService.postCustomApiConfigurationPublicShoppingCartProducts
    >
  >;
export type ConfigurationServicePostCustomApiConfigurationPublicShoppingCartByQuoteIdExcelMutationResult =
  Awaited<
    ReturnType<
      typeof ConfigurationService.postCustomApiConfigurationPublicShoppingCartByQuoteIdExcel
    >
  >;
export type ConfigurationServicePostCustomApiConfigurationPublicShoppingCartQuoteRequestMailMutationResult =
  Awaited<
    ReturnType<
      typeof ConfigurationService.postCustomApiConfigurationPublicShoppingCartQuoteRequestMail
    >
  >;
export type ConfigurationServicePutCustomApiConfigurationPublicShoppingCartConfigurationsByLineItemIdMutationResult =
  Awaited<
    ReturnType<
      typeof ConfigurationService.putCustomApiConfigurationPublicShoppingCartConfigurationsByLineItemId
    >
  >;
export type ConfigurationServicePutCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedDataMutationResult =
  Awaited<
    ReturnType<
      typeof ConfigurationService.putCustomApiConfigurationPublicShoppingCartByQuoteIdExtendedData
    >
  >;
export type ConfigurationServicePutCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedDataMutationResult =
  Awaited<
    ReturnType<
      typeof ConfigurationService.putCustomApiConfigurationPublicShoppingCartLineItemByLineItemIdExtendedData
    >
  >;
